export const OBTER_MODULOS = 'OBTER_MODULOS'
export const OBTER_MODULO = 'OBTER_MODULO'
export const ADICIONAR_MODULO = 'ADICIONAR_MODULO'